<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 08:46:22
 * @LastEditTime: 2021-05-25 08:54:33
-->
<template>
  <div class="projectManagement">
    <div class="project-top-filter">
      <Row>
        <Col>
          <Select
            v-model="projectSchemeId"
            style="width:200px"
            class="select-box"
            @on-change="changeBasic">
            <Option
              v-for="item in cityList"
              :value="item.value"
              :key="item.value">
              {{item.label}}
            </Option>
          </Select>
        </Col>
        <Col>
          <Select
            v-model="projectPrizeId"
            style="width:200px"
            @on-change="changePride"
            class="select-box">
            <Option
              v-for="item in cityLists"
              :value="item.value"
              :key="item.value">
              {{item.label}}
            </Option>
          </Select>
        </Col>
      </Row>
    </div>
    <div class="project-content">
      <div class="project-second-filter">
        <middle-filter @query="query" @reset="reset"></middle-filter>
        <div class="filter-box">
          <Button type="primary" @click.stop="addProject('add')">添加项目方案</Button>
        </div>
      </div>
      <div class="project-table-tab">
        <loading v-if="showSpin"></loading>
        <s-table
          class="list-table"
          :list="listData"
          :pageSize="pageSizeLeft"
          :total="listLeftTotal"
          :column="columnsLeft"
          :isLoading="false"
          :filterVisible="false"
          :currentPage="currentPageLeft"
          :showPageSize="true"
          @on-page-change="filterListLeft"
          @on-page-size-change="pageSize"></s-table>
        <i-filed-filter class="fieldStyle" :fields="items" @changeColumns="handleInput" />
      </div>
    </div>
    <Modal
      v-model="deleteDom"
      title="删除"
      @on-ok="ok"
      :mask-closable="false"
      @on-cancel="cancel">
      <p>确认删除此数据么？</p>
      <div slot="footer">
        <Button @click="cancel(false)">取消</Button>
        <Button type="primary" @click="ok">确定</Button>
      </div>
    </Modal>
    <project-alternatives
      :show="show"
      :cityLists.sync="cityLists"
      :cityList.sync="cityList"
      @showModel="closeModal"
      :title.sync="titleValue"
      :formValidates.sync="formValidate">
    </project-alternatives>
  </div>
</template>

<script>
import middleFilter from './components/middle-filter'
import $bus from '@/utils/bus.js'
import projectAlternatives from './components/project-alternatives'
import { mapActions } from 'vuex'
export default {
  components: {
    middleFilter,
    projectAlternatives,
  },
  provide() {
    return {
      yeye: '99',
    }
  },
  data() {
    return {
      visible: false,
      cityLists: [],
      cityList: [],
      projectSchemeIdValue: '',
      projectPrizeIdValue: '',
      projectSchemeId: '',
      projectPrizeId: '',
      showSpin: false,
      currentPageLeft: 1,
      pageSizeLeft: 10,
      listLeftTotal: 1,
      selectData: [], //选中的项
      columnsLeft: [],
      formValidate: {},
      deleteDom: false,
      deleteId: '',
      downLoadFormdata: {},
      columnList: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        //   fixedItem: true,
        //   checked: true,
        // },
        {
          title: '项目id',
          key: 'id',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '项目编号',
          key: 'projectCode',
          align: 'center',
          checked: true,
        },
        {
          title: '单位名称',
          key: 'organizationName',
          align: 'center',
          checked: true,
          tooltip: true,
        },
        {
          title: '排名',
          key: 'sort',
          align: 'center',
          checked: true,
        },
        {
          title: '票数',
          key: 'ticket',
          align: 'center',
          checked: true,
          sortable: true,
        },
        {
          key: 'operate',
          title: '操作',
          align: 'center',
          checked: 'true',
          render: (h, { row }) => {
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'space-around',
                },
              },
              [
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.detailsData(row.id)
                      },
                    },
                  },
                  '编辑',
                ),
                h(
                  'a',
                  {
                    on: {
                      click: () => {
                        this.getDeleteById(row.id)
                      },
                    },
                  },
                  '删除',
                ),
              ],
            )
          },
        },
      ], //列表项
      listData: [], //列表数据
      items: [],
      show: false,
      titleValue: 'add',
    }
  },
  async created() {
    const formValue = {
      projectName: '',
      projectCode: '',
      beginSort: '',
      endSort: '',
      minTicket: '',
      maxTicket: '',
    }
    this.columnsLeft = this.columnList.filter(element => element.checked)
    this.items = this.columnList
    await this.selectLevel(1)
    await this.selectLevel(2)
    await this.queryDataList(formValue)
  },
  methods: {
    changeBasic(val) {
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        projectSchemeId: val,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    changePride(val) {
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        projectPrizeId: val,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    //搜索
    closeModal(data) {
      this.show = data
      this.queryDataList(this.downLoadFormdata)
    },
    async selectLevel(name) {
      let level
      if (name === 1) {
        level = 1
      }
      if (name === 2) {
        level = 2
      }
      const dataObj = {
        level: level, //参会ID
      }
      const { dataResult } = await this.getselectList(dataObj)
      if (level === 1) {
        this.cityList = dataResult.map(res => {
          return {
            label: res.categoryName,
            value: res.id,
          }
        })
        this.projectSchemeId = this.cityList[0].value
      } else {
        this.cityLists = dataResult
          .filter(res => res.categoryName === '典型案例' || res.categoryName === '创新案例')
          .map(res => {
            return {
              label: res.categoryName,
              value: res.id,
            }
          })
        this.projectPrizeId = this.cityLists[0].value
      }
    },
    async detailsData(id) {
      this.formValidate = {}
      const formall = {
        projectId: id, projectSchemeId: this.projectSchemeId, projectPrizeId: this.projectPrizeId,
      }
      const res = await this.details(formall)
      this.formValidate = res.dataResult
      this.addProject('update')
    },
    async queryDataList(formValue) {
      const dataObj = {
        projectSchemeId: this.projectSchemeId,
        projectPrizeId: this.projectPrizeId,
        pageNo: this.currentPageLeft,
        pageSize: this.pageSizeLeft,
        ...formValue,
      }
      this.downLoadFormdata = dataObj
      const { dataResult, flag } = await this.getQueryDatalist(dataObj)
      if (flag !== '7') {
        this.listData = dataResult.rows
        this.listLeftTotal = dataResult.total
        this.currentPageLeft = dataResult.page
      }
    },
    addProject(value) {
      $bus.$emit('showDialog', '===================')
      this.formValidate.projectPrizeId = this.projectPrizeId
      this.formValidate.projectSchemeId = this.projectSchemeId
      // if (value === 'add') {
      //   this.formValidate.projectPrizeId = this.projectPrizeIdValue = ''
      //   this.formValidate.projectSchemeId = this.projectSchemeIdValue = ''
      // } else {
      //   this.formValidate.projectPrizeId = this.projectPrizeIdValue = this.projectPrizeId
      //   this.formValidate.projectSchemeId = this.projectSchemeIdValue = this.projectSchemeId
      // }
      this.titleValue = value
      this.show = true
    },
    // 删除
    async getDeleteById(id) {
      this.deleteId = id
      this.deleteDom = true
    },
    async ok() {
      const res = await this.deleteById({ id: this.deleteId })
      if (res.code === '0' && res.flag === '0') {
        this.deleteDom = false
        this.$Message.success('删除成功')
        this.queryDataList(this.downLoadFormdata)
      }
    },
    cancel() {
      this.$Message.info('已取消')
      this.deleteDom = false
    },
    //搜索
    query(data) {
      const dataList = {
        ...data,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(dataList)
    },
    //重置
    reset(data) {
      const dataListValue = {
        ...data,
        pageNo: 1,
        pageSize: 10,
      }
      this.queryDataList(dataListValue)
    },
    // 列表自定义
    handleInput(data) {
      this.columnsLeft = data.filter(element => element.checked)
    },
    pageSize(size = 10) {
      this.pageSizeLeft = size
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        pageSize: size,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    filterListLeft(page = 1) {
      this.currentPageLeft = page
      this.downLoadFormdata = {
        ...this.downLoadFormdata,
        pageNo: page,
      }
      this.queryDataList(this.downLoadFormdata)
    },
    ...mapActions({
      getQueryDatalist: 'jurisprudenceDaily/projectManagement/getQueryDatalist',
      getselectList: 'jurisprudenceDaily/projectManagement/getselectList',
      details: 'jurisprudenceDaily/projectManagement/details',
      deleteById: 'jurisprudenceDaily/projectManagement/deleteById',
    }),
  },
}
</script>

<style lang='scss' scoped>
.projectManagement {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  .project-content {
    padding: 20px;
    height: calc(100% - 70px);
  }
  .project-top-filter {
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    padding: 0 20px;
    .select-box {
      margin-right: 20px;
    }
    /deep/.ivu-row {
      display: flex;
      align-items: center;
      height: 70px;
    }
  }
  .project-second-filter {
    // padding: 20px;
    display: flex;
    justify-content: space-between;
    .filter {
      display: flex;
      > .filter-box {
        margin-right: 20px;
        button {
          margin-right: 10px;
        }
        label {
          width: 70px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 20px;
        }
        .centerLine {
          margin: 0 10px;
        }
      }
    }
  }
  .project-table-tab {
    margin-top: 10px;
    height: calc(100% - 32px);
    position: relative;
  }
}
</style>